import { useTranslation } from 'react-i18next';

interface ChartPlaceholderProps {
    readonly loading?: boolean;
    readonly hasData: boolean;
    readonly height?: number;
    readonly noDataKey?: string; // i18n key overrides
}

function ChartPlaceholder({
    loading = false,
    hasData,
    height = 210,
    noDataKey = 'statistics.charts.noData',
}: Readonly<ChartPlaceholderProps>): JSX.Element | null {
    const { t } = useTranslation();

    if (loading) {
        return (
            <div
                style={{
                    height,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {t('statistics.charts.loading', 'Loading chart...')}
            </div>
        );
    }

    if (!hasData) {
        return (
            <div
                style={{
                    height,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#888',
                }}
            >
                {t(noDataKey, 'No data available')}
            </div>
        );
    }

    return null;
}

export default ChartPlaceholder;
